// extracted by mini-css-extract-plugin
module.exports = {"conditions-area-wrapper":"conditions-area-wrapper"};